import React from 'react'
import DeskDashboard from '../Components/DeskDashboard'
import {
  OMM_TABS,
  buildOmmTabParams
} from '../../../../components/RecentPolicies/Components/RecentPoliciesWrapper'
import { AML_STAGE_LABEL } from '../../lib/makerCheckerQueues'
import { getUserBranch, hasAuthourity } from '../../../../lib/access.es6'

const NEW_BUSINESS = 'CAN_OMM_NEW_BUSINESS'
const AGENT = 'CAN_OMM_AGENT_BRANCH'

// Sales agents reach this page for the tabs carrying their own work; the review
// queue itself stays New Business's.
const NEW_BUSINESS_ONLY = [NEW_BUSINESS]
const NEW_BUSINESS_OR_AGENT = [NEW_BUSINESS, AGENT]

const [UN_CONFIRMED, NEED_ACTION, UN_PAID, COOL_OFF, REJECTED] = OMM_TABS

// buildOmmTabParams may already carry additional_details (it scopes sales
// agents and their managers to their own branch), so merge rather than replace.
function withDetails(params, extra) {
  return {
    ...params,
    additional_details: { ...(params.additional_details || {}), ...extra }
  }
}

// Every tab keys off the AML stage rather than its own. A policy is New
// Business's exactly when AML has approved it: approving the Quality Check
// activates the policy to Unpaid, and rejecting it moves the policy to
// Rejected, so Un_Confirmed + AML Approved can only mean "awaiting quality
// check", and Rejected + AML Approved can only mean "rejected here".
function tabs() {
  // An agent sees their own branch's book, not the partner's. Anyone who also
  // holds the New Business authority is back-office and stays unscoped.
  const branchScoped = hasAuthourity(AGENT) && !hasAuthourity(NEW_BUSINESS)
  const scope = function(params) {
    return branchScoped
      ? withDetails(params, { agent_branch: getUserBranch() })
      : params
  }

  return [
    {
      key: 'un-confirmed',
      label: UN_CONFIRMED.label,
      authorities: NEW_BUSINESS_ONLY,
      params: {
        ...buildOmmTabParams(UN_CONFIRMED),
        maker_check_label: AML_STAGE_LABEL,
        maker_check_status: 'Approved',
        fetchAll: true
      },
      needAction: UN_CONFIRMED.needAction,
      emptyMessage: 'No policies awaiting quality check.',
      showAmlFlag: true,
      showStage: true
    },
    {
      key: 'need-action',
      label: NEED_ACTION.label,
      params: scope(
        withDetails(buildOmmTabParams(NEED_ACTION), { need_action: true })
      ),
      emptyMessage: NEED_ACTION.emptyMessage,
      showAmlFlag: true,
      metricNote: 'Counted from when tracking went live (Nov 2026).'
    },
    {
      key: 'un-paid',
      label: UN_PAID.label,
      params: scope(buildOmmTabParams(UN_PAID)),
      showAmlFlag: true,
      processedLabel: 'Paid',
      metricNote: 'Came in counts policies activated by Quality Check.'
    },
    {
      key: 'cool-off',
      label: COOL_OFF.label,
      params: scope(buildOmmTabParams(COOL_OFF)),
      showAmlFlag: true,
      dateDiscriminator: 'start_date',
      processedLabel: 'Retained',
      metricNote:
        'Came in counts cover that started; retained is not cancelled.'
    },
    {
      key: 'rejected',
      label: REJECTED.label,
      params: scope({
        ...buildOmmTabParams(REJECTED),
        maker_check_label: AML_STAGE_LABEL,
        maker_check_status: 'Approved'
      }),
      emptyMessage: 'No policies rejected by New Business.',
      showAmlFlag: true
    }
  ]
}

const NewBusinessDashboard = props => (
  <DeskDashboard
    {...props}
    title="New Business"
    desk="new_business"
    tabs={tabs()}
  />
)

export default NewBusinessDashboard
